import { ShopCampioni } from "./ShopCampioni";
import { TabellaCampioni } from "./TabellaCampioni";
import { ShopMateriale } from "./ShopMateriale";
import { TabellaMateriale } from "./TabellaMateriale";
import { Richieste } from "./Richieste";
import { Servizi } from "./Servizi";
import { CampioniEventi } from "./CampioniEventi";

export const Campioni = {
  ShopCampioni: ShopCampioni,
  TabellaCampioni: TabellaCampioni,
  ShopMateriale: ShopMateriale,
  TabellaMateriale: TabellaMateriale,
  Richieste: Richieste,
  Servizi: Servizi,
  CampioniEventi: CampioniEventi,
};
